<!-- 推荐 -->
<template>
  <div class="mt-16 dis-flx al-c ju-c">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="ruleForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="获取验证码" prop="verificationCode">
          <el-col :span="15">
            <el-input v-model="ruleForm.verificationCode"></el-input>
          </el-col>
          <el-col :span="5">
            <el-button class="code" @click="handleYz" :disabled="disable">{{  buttonName  }}</el-button>
          </el-col>
        </el-form-item>
        <el-form-item>
          <div class="mt-100 dis-flx al-c ju-c">
            <el-button class="btn" type="primary" @click="goBootm()">下一步</el-button>
          </div>
        </el-form-item>
      </el-form>

  </div>
</template>
<script>
// import { register, sendTemplateMail } from "@/api/login";
export default {
  components: {

  },
  data() {

    return {
      buttonName: "获取验证码",
      count: 60,
      disable: false,
      ruleForm: {
        phone: '',
        verificationCode: ''
      },
      rules: {
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/, message: "请输入合法手机号/电话号", trigger: "blur" }
        ],
        verificationCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
      }
    };
  },

  watch: {},
  computed: {
  },
  created() {
  },
  mounted() {
    // this.drawLine();
  },
  methods: {
    handleYz() {
      var that = this
      var timeout = setInterval(() => {
        if (this.count < 1) {
          this.disable = false;
          this.buttonName = "获取验证码";
          this.count = 60;
          clearInterval(timeout);
        } else {
          this.disable = true;
          this.buttonName = this.count-- + "s后重发";
        }
      }, 1000);
      if (!that.disable) {
        // that.sendTemplateMail()
      }
    },
    goBootm() {
      var that = this
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('activeNum', 1)
          localStorage.setItem('phone', this.ruleForm.phone);
        } else {
          console.log('error submit!!');
          return false;
        }
      });


    }
  }
};
</script>
<style>
.sf_slf_selt .el-input__inner {
  width: 166px;
  height: 32px;
  line-height: 32px;
  background: #FFFFFF;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #D2D2D2;
  font-size: 16px;
}

.sf_slf_selt .el-input__icon {
  line-height: 32px;
}

.sf_slf_divider .el-divider--horizontal {
  margin: 16px 0;
}

.bf_reg_me .el-checkbox__label {
  font-size: 16px;
}
.bfa_self_btn2 .el-button--primary{
    background-color: #1067E0;
      border-color: #1067E0;
  }
</style>
<style scoped>
.pd-lr-24 {
  padding: 0 24px;
}

.sf_card {
  width: 100%;
  height: 481px;
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
  border: 1px solid #E7E7E7;
}

.infinite-list {
  height: 381px;
  overflow: auto;
  line-height: 30px;
}

.fp_ip_wh {
  width: 400px;
}
>>>.el-input__inner {
    height: 56px;
    padding-left: 40px;
    line-height: 56px;
    font-size: 14px;
  }
  >>>.el-form-item__label{
    font-size: 17px;
    margin-top: 7px;
  }
  .code {
    width: 125px;
    height: 56px;
    text-align: center;
    border-radius: 8px;
    border: 1px solid #215ACE;
    color: #215ACE;
    font-size: 18px;
    margin-left: 5px;
  }
  .btn {
    width: 100%;
    height: 50px;
    background: #0177FB;
    border-radius: 8px;
    border: 1px solid #0177FB;
    font-size: 24px;
    color: #FFFFFF;
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/forgetPassword/sfForm.vue